import { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
	BookOutlined,
	ControlOutlined,
	HomeOutlined,
	ReadOutlined,
	SettingOutlined,
	UnorderedListOutlined,
	UserOutlined
} from '@ant-design/icons'
import {
	RNChecks,
	RNHome,
	RNJournal,
	RNLearning,
	RNProfile,
	RNRelay,
	RNUsers
} from '../helpers/routeNames'
import '../styles/AppLayout.scss'

interface NavItem {
	title: string
	Icon: FC<{ className?: string }>
	link: string
	/** Match sub-paths too (e.g. /relay/* still highlights Реле) */
	matchPrefix?: boolean
}

const ADMIN_ITEMS: NavItem[] = [
	{ title: 'Главная', Icon: HomeOutlined, link: RNHome },
	{
		title: 'Реле',
		Icon: ControlOutlined,
		link: RNRelay,
		matchPrefix: true
	},
	{
		title: 'Характ.',
		Icon: UnorderedListOutlined,
		link: RNChecks,
		matchPrefix: true
	},
	{
		title: 'Журнал',
		Icon: BookOutlined,
		link: RNJournal,
		matchPrefix: true
	},
	{
		title: 'Работники',
		Icon: UserOutlined,
		link: RNUsers,
		matchPrefix: true
	},
	{
		title: 'Знания',
		Icon: ReadOutlined,
		link: RNLearning,
		matchPrefix: true
	},
	{ title: 'Профиль', Icon: SettingOutlined, link: RNProfile }
]

const WORKER_ITEMS: NavItem[] = [
	{ title: 'Главная', Icon: HomeOutlined, link: RNHome },
	{
		title: 'Характ.',
		Icon: UnorderedListOutlined,
		link: RNChecks,
		matchPrefix: true
	},
	{
		title: 'Журнал',
		Icon: BookOutlined,
		link: RNJournal,
		matchPrefix: true
	},
	{
		title: 'Знания',
		Icon: ReadOutlined,
		link: RNLearning,
		matchPrefix: true
	},
	{ title: 'Профиль', Icon: SettingOutlined, link: RNProfile }
]

interface NavBarProps {
	role: 'admin' | 'worker' | string
}

export const NavBar: FC<NavBarProps> = ({ role }) => {
	const location = useLocation()
	const items =
		role === 'admin' || role === 'supervisor'
			? ADMIN_ITEMS
			: WORKER_ITEMS

	const isActive = (item: NavItem) => {
		if (item.link === RNHome) {
			return location.pathname === RNHome
		}
		if (item.matchPrefix) {
			return location.pathname.startsWith(item.link)
		}
		return location.pathname === item.link
	}

	return (
		<footer className="app-nav" role="navigation" aria-label="Главное меню">
			{items.map((item) => (
				<Link
					key={item.link}
					to={item.link}
					className={`app-nav-item${isActive(item) ? ' active' : ''}`}
					aria-current={isActive(item) ? 'page' : undefined}>
					<item.Icon className="app-nav-icon" />
					<span className="app-nav-label">{item.title}</span>
				</Link>
			))}
		</footer>
	)
}
